import { MenuOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { arrayMoveImmutable } from 'array-move';
import React from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
const DragHandle = SortableHandle((props) => (
    <div className="flex flex-row items-center justify-center gap-3">

        <MenuOutlined
            style={{
                cursor: props.canSort ? 'grab' : 'default',
                color: '#999',
            }}
        />
        {props.children}
    </div>
));

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

const SortableTable = ({canSort = true, sortLabel = "Sort",children, onSortChange = () => true, dataSource = [],...props}) => {
    const onSortEnd = ({ oldIndex, newIndex }) => {
        let source = [...dataSource];
        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable(source.slice(), oldIndex, newIndex).filter(
                (el) => !!el,
            );
            console.log('Sorted items: ', newData);
            onSortChange(newData);
        }
    };
    const DraggableContainer = (dragProps) => (
        <SortableBody
            useDragHandle
            disableAutoscroll
            helperClass="row-dragging"
            onSortEnd={onSortEnd}
            {...dragProps}
        />
    );

    const DraggableBodyRow = ({ className, style, ...restProps }) => {
        // function findIndex base on Table rowKey props and should always be a right array index
        const index = dataSource.findIndex((x) => x[props.rowKey || 'display_index'] === restProps['data-row-key']);
        return <SortableItem index={index} {...restProps} className={className}/>;
    };

    return (
        <Table
            {...props}
            dataSource={dataSource}
            components={canSort ? {
                body: {
                    wrapper: DraggableContainer,
                    row: DraggableBodyRow,
                },
            } : undefined}
        >

                <Table.Column
                    title={sortLabel}
                    dataIndex="sort"
                    width={30}
                    className={canSort ? "drag-visible" : undefined}
                    render={(_, member) => (
                        <DragHandle canSort={canSort}>
                            <p className="text-base font-semibold">
                                {member[props.rowKey || 'display_index']}
                            </p>
                        </DragHandle>
                    )}/>

                {children}
        </Table>
    )
};

export default SortableTable;